<template>
  <div class="popup-container">
    <a v-if="!popup.id.includes('popup-error') && !popup.id.includes('popup-finish') && !popup.id.includes('popup-info') && !popup.id.includes('popup-unauthorized')" class="popup-trigger" :title="popup.linktitle" :href="'#' + popup.id">{{popup.link}}</a>

    <div :id="popup.id" class="simple-popup magic-popup mfp-hide">

      <div class="popup-content">
        <h3 v-if="popup.title" v-html="popup.title"></h3>
        <div v-html="popup.content"></div>
        <div class="forbidden-access" v-if="popup.unauthorized">
          <div class="icon">
            <span class="lock-icon"></span>
          </div>
          <div class="content">
            <h3>Accès non autorisé</h3>
            <p>Pour pouvoir accéder à cette page, vous devez vous identifier ou vous inscrire si vous n'avez pas encore de compte</p>
            <router-link class="bt-abo red-btn" :to="{name: 'DashboardSubscription'}">S'abonner</router-link>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import { registrationHelpers } from '../../main'

export default {
  name: 'simple-popup',
  props: ['popup'],
  data() {
    return {
    }
  },
  mounted: function () {
    $.extend(true, $.magnificPopup.defaults, {
      tClose: 'Fermer (Esc)',
      tLoading: 'Chargement...',
      image: {
        tError: '<a href="%url%">L\'image</a> n\'a pu être chargée.', // Error message when image could not be loaded
      },
      ajax: {
        tError: '<a href="%url%">Le contenu</a> ne peut-être chargé.<br><a href="%url%">Cliquez-ici</a>', // Error message when ajax request failed
      },
    })
    const hauteurFenetre = document.documentElement.clientHeight
    const hauteurPopup = hauteurFenetre - 40
    const close = true
    $('.popup-trigger').magnificPopup({
      type: 'inline',
      fixedContentPos: true,
      fixedBgPos: true,
      overflowY: 'auto',
      mainClass: 'mfp-fade',
      callbacks: {
        open: function () {
          console.log('e')
          $('.scroller').scrollbar({
            showArrows: true,
          })
        },
        resize: function () {
          const hauteurFenetre = document.documentElement.clientHeight
          const hauteurPopup = hauteurFenetre - 40
          const hauteurTitre = $('.container-content-popup h1').height()
          const hauteurContainerTexte = (hauteurPopup - hauteurTitre) - 98// padding container + padding-bottom;

          $('.container-content-popup > div').css('height', hauteurContainerTexte)
          $('.container-content-popup').css('height', hauteurPopup)
        },
      },
    })
  },
}
</script>
